module.exports = __webpack_public_path__ + "img/hand.8695472.png";